var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedallaConquistador(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Medalla_Conquistador",
    "data-name": "Medalla Conquistador",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 204,
    viewBox: "0 0 200 204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86276",
    "data-name": "Rect\\xE1ngulo 86276",
    width: 200,
    height: 204,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86270",
    "data-name": "Rect\\xE1ngulo 86270",
    width: 143.862,
    height: 147.716,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86269",
    "data-name": "Rect\\xE1ngulo 86269",
    width: 156.763,
    height: 161.339,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107603",
    "data-name": "Trazado 107603",
    d: "M57.78,42.554a2.649,2.649,0,0,0-2.568,2.717v73.579a2.787,2.787,0,0,0,.894,2.061l41.726,37.873a2.472,2.472,0,0,0,1.607.645h.116q.081,0,.162-.009h0c.5-38.951,1.095-77.9,2.374-116.839v-.027Z",
    transform: "translate(-55.211 -42.554)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107610",
    "data-name": "Trazado 107610",
    d: "M57.78,42.554a2.648,2.648,0,0,0-2.568,2.716v73.58a2.779,2.779,0,0,0,.894,2.06L97.83,158.784a2.471,2.471,0,0,0,3.323.027l43.09-37.9a2.775,2.775,0,0,0,.925-2.086V45.271a2.647,2.647,0,0,0-2.575-2.717Z",
    transform: "translate(-55.211 -42.554)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86273",
    "data-name": "Rect\\xE1ngulo 86273",
    width: 80.223,
    height: 103.941,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19231",
    "data-name": "Grupo 19231",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19212",
    "data-name": "Grupo 19212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19211",
    "data-name": "Grupo 19211",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107600",
    "data-name": "Trazado 107600",
    d: "M41.49,177.4l2.474,8.311h-.01l.009.024L12.92,194.88l1.173-13.416-7.878-9.1L23.726,167.2l-5.789-16.923s1.834-.726,5.237-1.845A81.575,81.575,0,1,1,176.083,91.542a82.214,82.214,0,0,1-.017,56.938q2.544.864,5.095,1.8l-5.574,16.94,17.459,5.365-7.8,9.922,1.377,13.032-30.832-9.476.008-.026h-.008l.121-.411,2.481-8.867a81.142,81.142,0,0,1-115.079,2.452q-.924-.891-1.822-1.81Z",
    transform: "translate(-0.018 0.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107601",
    "data-name": "Trazado 107601",
    d: "M41.49,177.4l2.474,8.311h-.01l.009.024L12.92,194.88l1.173-13.416-7.878-9.1L23.726,167.2l-5.789-16.923s1.834-.726,5.237-1.845A81.575,81.575,0,1,1,176.083,91.542a82.214,82.214,0,0,1-.017,56.938q2.544.864,5.095,1.8l-5.574,16.94,17.459,5.365-7.8,9.922,1.377,13.032-30.832-9.476.008-.026h-.008l.121-.411,2.481-8.867a81.142,81.142,0,0,1-115.079,2.452q-.924-.891-1.822-1.81Z",
    transform: "translate(-0.018 0.053)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107602",
    "data-name": "Trazado 107602",
    d: "M177.927,120.872a76.746,76.746,0,1,1-76.745-77.08,76.913,76.913,0,0,1,76.745,77.08",
    transform: "translate(-0.072 0.061)",
    fill: "#e5f1f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19219",
    "data-name": "Grupo 19219",
    transform: "translate(28.253 42.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19218",
    "data-name": "Grupo 19218",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19217",
    "data-name": "Grupo 19217",
    transform: "translate(-28.169 -22.195)",
    opacity: 0.37
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19216",
    "data-name": "Grupo 19216",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19215",
    "data-name": "Grupo 19215",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19214",
    "data-name": "Grupo 19214",
    transform: "translate(54.964 22.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19213",
    "data-name": "Grupo 19213",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86268",
    "data-name": "Rect\\xE1ngulo 86268",
    width: 122.392,
    height: 105.776,
    transform: "matrix(0.579, -0.815, 0.815, 0.579, -54.964, 77.716)",
    fill: "#58948f"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19221",
    "data-name": "Grupo 19221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19220",
    "data-name": "Grupo 19220",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107604",
    "data-name": "Trazado 107604",
    d: "M157.048,152.631l-.652-.365A63.527,63.527,0,1,0,37.5,121.31a64,64,0,0,0,7.758,30.556l-.656.36A64.274,64.274,0,1,1,165.121,121.31a64.721,64.721,0,0,1-8.073,31.321",
    transform: "translate(-0.109 0.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107605",
    "data-name": "Trazado 107605",
    d: "M136.415,168.117,134.3,166.9l-2.193,1.055.5-2.392L130.93,163.8l2.418-.262,1.159-2.149,1,2.23,2.393.44-1.8,1.64Z",
    transform: "translate(-0.388 0.223)",
    fill: "#ce2017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107606",
    "data-name": "Trazado 107606",
    d: "M141.73,155.761a1.69,1.69,0,1,1,1.691,1.7h0a1.692,1.692,0,0,1-1.688-1.7",
    transform: "translate(-0.42 0.213)",
    fill: "#29304a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107607",
    "data-name": "Trazado 107607",
    d: "M66.386,168.117l2.108-1.214,2.193,1.055-.5-2.392,1.679-1.766-2.418-.262-1.156-2.151-1,2.23-2.393.44,1.806,1.64Z",
    transform: "translate(-0.192 0.223)",
    fill: "#ce2017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107608",
    "data-name": "Trazado 107608",
    d: "M61.079,155.761a1.689,1.689,0,1,0-1.688,1.7h0a1.692,1.692,0,0,0,1.688-1.694Z",
    transform: "translate(-0.171 0.213)",
    fill: "#29304a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107609",
    "data-name": "Trazado 107609",
    d: "M47.628,61.757V38.675a2.958,2.958,0,0,1,2.965-2.954h97.765a2.957,2.957,0,0,1,2.96,2.954V53.746",
    transform: "translate(-0.141 0.049)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19223",
    "data-name": "Grupo 19223",
    transform: "translate(55.048 42.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19222",
    "data-name": "Grupo 19222",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86272",
    "data-name": "Rect\\xE1ngulo 86272",
    width: 147.555,
    height: 141.046,
    transform: "translate(-55.048 77.837) rotate(-54.609)",
    fill: "#7eccc9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19228",
    "data-name": "Grupo 19228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19227",
    "data-name": "Grupo 19227",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107611",
    "data-name": "Trazado 107611",
    d: "M102.44,185.934l-1.695-3.458-3.8-.555,2.749-2.693-.649-3.805,3.4,1.794,3.4-1.794-.649,3.805,2.749,2.693-3.8.555Z",
    transform: "translate(-0.287 0.243)",
    fill: "#91ac49"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19226",
    "data-name": "Grupo 19226",
    transform: "translate(60.532 48.121)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19225",
    "data-name": "Grupo 19225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19224",
    "data-name": "Grupo 19224",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107612",
    "data-name": "Trazado 107612",
    d: "M63.473,48.554a2.331,2.331,0,0,0-2.261,2.391v64.8A2.442,2.442,0,0,0,62,117.56l36.747,33.355a2.175,2.175,0,0,0,2.926.024l37.949-33.374a2.447,2.447,0,0,0,.817-1.838V50.946a2.333,2.333,0,0,0-2.269-2.392Z",
    transform: "translate(-60.713 -48.053)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107613",
    "data-name": "Trazado 107613",
    d: "M13.217,170.015l29.221-8.591,6.309,21.146-29.221,8.588,1.109-12.6Z",
    transform: "translate(-0.039 0.223)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107614",
    "data-name": "Trazado 107614",
    d: "M34.007,177.525s5.422-1.856,7.247-2.412c1.224-.371,4.932-1.37,4.932-1.37l2.623,8.791Z",
    transform: "translate(-0.101 0.241)",
    fill: "#72b5b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107615",
    "data-name": "Trazado 107615",
    d: "M189.5,170.224l-29.025-8.9-6.044,21.554,29.022,8.9-1.3-12.237Z",
    transform: "translate(-0.457 0.223)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107616",
    "data-name": "Trazado 107616",
    d: "M168.986,177.534s-5.117-1.966-6.945-2.523c-1.221-.372-4.854-1.486-4.854-1.486l-2.759,9.313Z",
    transform: "translate(-0.457 0.24)",
    fill: "#72b5b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107617",
    "data-name": "Trazado 107617",
    d: "M33.978,177.585l-9.694-28.272s73.9-29.209,153.643,0L168.6,177.585s-58.751-25.535-134.624,0",
    transform: "translate(-0.072 0.189)",
    fill: "#b1e0de"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "C",
    transform: "translate(40.859 160.315) rotate(-19.631)",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    id: "O",
    transform: "translate(51.261 157.733) rotate(-15.311)",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "N",
    transform: "translate(62.215 154.806) rotate(-11.463)",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    id: "Q",
    transform: "translate(72.695 152.729) rotate(-7.759)",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q")), /*#__PURE__*/React.createElement("text", {
    id: "U",
    transform: "matrix(0.997, -0.071, 0.071, 0.997, 83.874, 150.269)",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U")), /*#__PURE__*/React.createElement("text", {
    id: "I",
    transform: "matrix(1, -0.025, 0.025, 1, 94.541, 148.611)",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(99.962 149.469) rotate(1.126)",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    id: "T",
    transform: "translate(110.035 149.737) rotate(4.365)",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "A",
    transform: "translate(118.406 151.395) rotate(7.425)",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    id: "D",
    transform: "translate(129.17 151.862) rotate(10.992)",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D")), /*#__PURE__*/React.createElement("text", {
    id: "O-2",
    "data-name": "O",
    transform: "matrix(0.968, 0.253, -0.253, 0.968, 139.687, 153.972)",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "R",
    transform: "translate(150.708 156.945) rotate(18.243)",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19230",
    "data-name": "Grupo 19230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19229",
    "data-name": "Grupo 19229",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107618",
    "data-name": "Trazado 107618",
    d: "M71.173,127.189l13.219-25.2.674-1.22h5.8l7.823-10.335,27.786,35.939v.813Z",
    transform: "translate(-0.211 0.125)",
    fill: "#cad79f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107619",
    "data-name": "Trazado 107619",
    d: "M69.55,126.284q3.438-6.2,6.875-12.405c2.42-4.377,4.846-8.751,7.238-13.143a1.826,1.826,0,0,1,1.828-1.09q2.022.057,4.046-.009a1.208,1.208,0,0,0,.816-.418q2.029-2.659,3.982-5.377a1.91,1.91,0,0,0,.292-1.056q.024-14.6.013-29.193c0-2.863.72-3.911,3.372-4.908h1.348a4.359,4.359,0,0,1,3.151,2.71h.83q14.021,0,28.044-.014a1.821,1.821,0,0,1,1.832.962v.813c-2.218,3.3-4.429,6.611-6.664,9.9a.788.788,0,0,0,0,1.056c2.235,3.291,4.446,6.6,6.664,9.9v.813a1.826,1.826,0,0,1-1.833.961q-13.891-.033-27.782-.013h-.869V87.64a20.065,20.065,0,0,1-.02,2.706,6.628,6.628,0,0,0,1.854,5.5c1.818,2.115,3.423,4.414,5.118,6.634.083.108.167.214.241.326a1.365,1.365,0,0,1-.247,1.928,1.314,1.314,0,0,1-1.9-.313c-1.231-1.582-2.441-3.182-3.658-4.776q-2.5-3.278-5-6.555c-.12-.157-.253-.3-.422-.5-.178.219-.336.4-.478.591-2.039,2.752-4.092,5.494-6.1,8.266a2.035,2.035,0,0,1-1.876.934c-1.28-.04-2.562-.032-3.843.008a1,1,0,0,0-.737.393Q79.5,113.854,73.4,124.959c-.051.093-.086.2-.15.344h50.4c-.132-.2-.225-.37-.34-.52-2.637-3.458-5.284-6.908-7.9-10.379a2.294,2.294,0,0,1-.453-1.218,1.147,1.147,0,0,1,.9-1.134,1.286,1.286,0,0,1,1.5.489c1.008,1.3,2,2.609,3,3.916l6.891,9.025c.864,1.133.771,1.781-.374,2.563H69.55Zm33.23-62.161v18.9h26.491c-.159-.251-.272-.442-.4-.625q-2.6-3.871-5.2-7.741a1.488,1.488,0,0,1,.006-2.147q2.616-3.9,5.236-7.8c.117-.173.225-.351.375-.587Zm-2.747,25.629V63.1a4.151,4.151,0,0,0-.011-.473,1.342,1.342,0,0,0-2.675,0,5.368,5.368,0,0,0-.012.608V89.656c1.14-.966,1.64-.956,2.7.1",
    transform: "translate(-0.206 0.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107620",
    "data-name": "Trazado 107620",
    d: "M114.045,108.4a1.345,1.345,0,1,1-2.689.013,1.345,1.345,0,0,1,2.689-.013",
    transform: "translate(-0.33 0.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107621",
    "data-name": "Trazado 107621",
    d: "M102.879,64.116h26.512c-.15.235-.258.414-.375.587q-2.619,3.9-5.236,7.8a1.488,1.488,0,0,0-.006,2.147q2.6,3.871,5.2,7.741c.124.183.236.374.4.625H102.879Z",
    transform: "translate(-0.305 0.089)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107622",
    "data-name": "Trazado 107622",
    d: "M100.116,89.749c-1.058-1.053-1.558-1.063-2.7-.1V63.231a5.368,5.368,0,0,1,.012-.608,1.342,1.342,0,0,1,2.675,0,4.151,4.151,0,0,1,.011.473V89.749",
    transform: "translate(-0.288 0.085)",
    fill: "#fed5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107623",
    "data-name": "Trazado 107623",
    d: "M120.005,73.406a6.532,6.532,0,1,1-6.532-6.573,6.553,6.553,0,0,1,6.532,6.573",
    transform: "translate(-0.317 0.093)",
    fill: "#fdab68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107624",
    "data-name": "Trazado 107624",
    d: "M118.252,73.429A4.748,4.748,0,1,1,113.5,68.65a4.764,4.764,0,0,1,4.748,4.779",
    transform: "translate(-0.322 0.095)",
    fill: "#fed5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107625",
    "data-name": "Trazado 107625",
    d: "M105.933,72.738l.018.18c0,.023.006.046.007.056a7.562,7.562,0,0,1,7.621-7.145,7.275,7.275,0,0,1,5.1,2.121,7.447,7.447,0,0,1,2.306,5.043c0-.035.012-.076.018-.116v1.036c-.006-.025-.011-.051-.017-.076a7.57,7.57,0,0,1-7.065,7.136l.149.019h-1.332l.271-.019a7.553,7.553,0,0,1-7.05-7.133l-.007.057c-.007.085-.015.17-.023.256Zm1.01.658a6.527,6.527,0,1,0,6.529-6.553,6.533,6.533,0,0,0-6.529,6.553",
    transform: "translate(-0.314 0.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107626",
    "data-name": "Trazado 107626",
    d: "M113.485,78.719a5.207,5.207,0,0,1-1.711-.284,5.292,5.292,0,0,1-2.321-1.589,5.2,5.2,0,0,1-1.016-1.856,5.009,5.009,0,0,1-.216-1.124c-.01-.176-.024-.354-.022-.53a5.181,5.181,0,0,1,.181-1.314c.019-.077.041-.154.067-.23a.5.5,0,0,1,.6-.335.508.508,0,0,1,.37.6c-.048.207-.106.412-.144.621a4.062,4.062,0,0,0-.049,1.089,4.194,4.194,0,0,0,.286,1.223,4.273,4.273,0,0,0,1.5,1.914,3.915,3.915,0,0,0,1.632.709,4.177,4.177,0,0,0,4.169-1.528,3.936,3.936,0,0,0,.844-1.789,4.225,4.225,0,0,0-.728-3.421A4.259,4.259,0,0,0,112.2,69.3a.493.493,0,0,1-.562-.168.506.506,0,0,1,.253-.8,4.48,4.48,0,0,1,.817-.191,5.429,5.429,0,0,1,.962-.05,5.12,5.12,0,0,1,1.444.258,5.206,5.206,0,0,1,1.451.75,5.321,5.321,0,0,1,2.084,3.249,4.989,4.989,0,0,1,.1,1.3,5.342,5.342,0,0,1-2.519,4.281,5.188,5.188,0,0,1-1.6.655,5.109,5.109,0,0,1-1.15.129",
    transform: "translate(-0.32 0.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107627",
    "data-name": "Trazado 107627",
    d: "M112.979,76.062c0-.157,0-.153-.14-.207a2.935,2.935,0,0,1-.35-.152.5.5,0,0,1,.205-.942.788.788,0,0,1,.255.051c.084.025.162.068.244.1a.5.5,0,0,0,.4-.91c-.168-.085-.345-.15-.518-.223a1.514,1.514,0,0,1-.144-2.765.085.085,0,0,0,.056-.09,2.8,2.8,0,0,1,.012-.378.492.492,0,0,1,.49-.43.5.5,0,0,1,.495.44,1.747,1.747,0,0,1,.01.27c0,.064.024.085.08.105a3.878,3.878,0,0,1,.418.169.5.5,0,0,1-.227.947A1.007,1.007,0,0,1,114,71.98c-.11-.034-.214-.087-.326-.11a.477.477,0,0,0-.533.312.49.49,0,0,0,.225.612c.175.085.357.155.536.229a1.529,1.529,0,0,1,.854.818,1.509,1.509,0,0,1-.659,1.927.163.163,0,0,0-.1.178,1.652,1.652,0,0,1-.011.321.5.5,0,0,1-.982-.005c-.009-.066-.012-.133-.018-.2",
    transform: "translate(-0.332 0.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107628",
    "data-name": "Trazado 107628",
    d: "M109.607,70a.5.5,0,0,1,.494-.507.507.507,0,1,1-.494.507",
    transform: "translate(-0.325 0.096)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedallaConquistador);
export default __webpack_public_path__ + "static/media/medallaConquistador.79a8b40fefd3361311637d4919601f02.svg";
export { ForwardRef as ReactComponent };